import { IDropdownOption } from "@fluentui/react/lib/Dropdown";
import { SocialAccountType } from "../../models/SocialAccountModel";

export class SocialAccountUtils {
    public static getTypeOptions(): IDropdownOption[] {
        const list = [
            { key: SocialAccountType.facebook, text: "Facebook" },
            { key: SocialAccountType.telegram, text: "Telegram" },
            { key: SocialAccountType.twitter, text: "Twitter" },
        ];

        return list;
    }
}